// /**
//  *
//  * @param departDate {Date}
//  * @param returnDate {Date?}
//  * @param singleTripCost {Number}
//  * @return number
//  */
// export function calculateTripCost(departDate, returnDate, singleTripCost) {
//   const format = "HH:mm"
//   console.log("departDate?=?=", departDate)
//
//   let tripCost = singleTripCost
//   let departDateMoment = this.$moment(departDate)
//   let returnDateMoment = returnDate ? this.$moment(returnDate) : null
//
//   const afterTime = this.$moment("19:00", format),
//       beforeTime = this.$moment("07:00", format)
//   // console.log("time now????", this.$moment().toDate())
//   console.log("departTime ==", departDateMoment.format("dd MM yyyy HH:mm:ss"))
//   // console.log("beforeTime", beforeTime.format('dd MM yyyy HH:mm:ss'))
//   // // console.log("afterTime", afterTime.format('dd MM yyyy HH:mm'))
//   // console.log("departTime isBetween?", departTime > beforeTime)
//
//   if(departDateMoment.hour() >=  afterTime.hour() || departDateMoment.hour() < beforeTime.hour()){
//     tripCost = tripCost + getPercentage(singleTripCost, 15)
//   }
//
//   if(returnDateMoment) {
//     if(returnDateMoment.hour() >=  afterTime.hour() || returnDateMoment.hour() < beforeTime.hour()){
//       tripCost += getPercentage(singleTripCost, 15)
//     }
//
//     tripCost += singleTripCost
//
//   }
//
//
//   // console.log("returnTime", returnTime)
//
//   return Math.round(tripCost)
//
//
//
// }

exports.getPercentage = (num, per) =>
{
  return (num/100)*per
}

exports.getLastMinuteEarningsIncreasePercent = (cost) => {
  const totalCost = Number(cost?.totalCost)
  const commission = Number(cost?.companyCommission)
  const originalEarnings = totalCost - (commission * 2)
  if (!Number.isFinite(totalCost) || !Number.isFinite(commission) || originalEarnings <= 0)
    return null
  return Math.round((commission / originalEarnings) * 1000) / 10
}

// /**
//  *
//  * @param date {FirebaseFirestore.Timestamp| Date | String }
//  * @returns {moment.Moment} for checking use moment.isValid()
//  */
// exports.getMomentDate = (date = new Date()) => {
//   if (date instanceof admin.firestore.Timestamp) {
//     return this.$moment(date.toDate())
//   } else if (date instanceof Date) {
//     return this.$moment(date)
//   } else
//     return this.$moment(date) //`returns invalid Moment object`
// }

exports.getStatusClass = (val) => {
  // type (primary|info|danger|default|warning|success)
  switch (val) {
    case "ACTIVE":
    case "VERIFIED":
    case "REFUNDED":
    case "PAID":
      return "bg-gradient-green"
    case "PENDING":
    case "PENDING_REFUND":
      return "bg-warning"
    case "CLAIMED":
      return "bg-blue"
    case "FINISHED":
      return "bg-black"
    case "NO_SHOW":
      return "bg-gradient-gray"
    case "ABANDONED":
      return "bg-gradient-orange"
    default:
      return "bg-danger"
  }
}

exports.toCents = (val) => {
  return parseFloat(val).toFixed(2) * 100
}

exports.countDecimals = (val) => {
  if(Math.floor(this.valueOf()) === this.valueOf()) return 0
  return this.toString().split(".")[1].length || 0
}

exports.isoCountryCodeToFlagEmoji = (country) => {
  return String.fromCodePoint(...[...country.toUpperCase()].map(c => c.charCodeAt() + 0x1F1A5))
}

exports.isWindows = navigator.platform.indexOf("Win") > -1


exports.getDuration = (start, end) => {
  const difMinutes = end.diff(start, "minutes", true)
  if (difMinutes > 60){
    var hours = Math.floor(difMinutes / 60)
    var minutes = difMinutes % 60
    return hours + "h " + (minutes > 0 ? minutes +"m" : "")
  }
  return difMinutes+"m"
}

exports.removeIntonations = function (text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}


exports.mimeTypeToExtensionMap = function (mimeType){
  const types = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/pjpeg": ".jpg", // just in case
    "image/svg+xml": ".svg",
    "image/webp": ".webp",
    "application/pdf": ".pdf",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
    "text/csv": ".csv",
    "application/vnd.ms-excel": ".xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
    "application/vnd.oasis.opendocument.spreadsheet": ".ods",
    "application/vnd.apple.pages": ".pages"
  }
  return types[mimeType] || ""
}
